import {
  REACT_APP_COOKIES_DOMAIN,
  STORAGE_PRFX,
  REACT_APP_ANALYTICS_APP_URL,
  REACT_APP_ABIS_APP_URL,
} from './constants';
import { roles } from './env';
import dateFns from 'date-fns';

export const calculateNumberOfSurveyQuestions = questionaire => {
  return [].concat
    .apply(
      [],
      ((questionaire.draft_data || []).pages || []).map(page => page.questions)
    )
    .filter(
      question =>
        question.type !== 'section' &&
        question.type !== 'section-break' &&
        question.type !== 'intro-text'
    ).length;
};

export const setActiveSurvey = surveyId => {
  setCookie('survey_id', surveyId);
};

export const getActiveSurvey = () => {
  return getCookie('survey_id');
};

export const styledDate = (dateValue, intl) => {
  var oneDay = 24 * 60 * 60 * 1000;
  var currentdate = new Date();
  var days = Math.abs(currentdate - new Date(dateValue)) / oneDay;

  if (days <= 1) {
    return intl.formatDate(dateValue, {
      hour: 'numeric',
      minute: 'numeric'
    });
  } else if (days <= 7) {
    return intl.formatDate(dateValue, {
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    });
  } else {
    return intl.formatDate(dateValue, {
      year: 'numeric',
      day: 'numeric',
      month: 'short'
    });
  }
};

// ::: cookie
export const setCookie = (cname, cvalue, exdays = 7) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  // document.cookie = cname + '=' + cvalue + ';' + expires + ';domain=${REACT_APP_COOKIES_DOMAIN}';
  document.cookie = `${STORAGE_PRFX + cname}=${cvalue};${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
};

export const getCookie = cname => {
  var name = STORAGE_PRFX + cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.split('=')[1].length !== 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return '';
};
export const delCookie = cname => {
  var expires = 'expires=-1';
  document.cookie = `${STORAGE_PRFX + cname}=;${expires};path=/;domain=${REACT_APP_COOKIES_DOMAIN}`;
  // cname + '=' + ';' + expires + ';path=/';
  // document.cookie=`${cname}=;expires=Wed; 01 Jan 1970`
};

// ::: storage
export const setStorage = (name, value) => {
  return localStorage.setItem(STORAGE_PRFX + name, value);
}
export const getStorage = (name, value) => {
  return localStorage.getItem(STORAGE_PRFX + name, value);
}
export const delStorage = (name) => {
  return localStorage.removeItem(STORAGE_PRFX + name);
}

export const rerouteUser = user => {
  const canAccessAbis = hasP('ACCESS_ABIS', user.role);
  const canAccessAnalytics = hasP('ACCESS_ANALYTICS', user.role);

  if (canAccessAnalytics) {
    return window.location.assign(`${REACT_APP_ANALYTICS_APP_URL}/en/`);
  }

  if (canAccessAbis) {
    return window.location.assign(`${REACT_APP_ABIS_APP_URL}/en/`);
  }
};

const randId = length => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const idGenerator = formId => {
  return dateFns.format(new Date(), 'YYMMDDHHssSSS') + randId(4) + '-' + formId;
};

// check permission
export const hasP = (permission, myRole = '') => {
  const thisRole = getUserCookie().role;
  if (thisRole) {
    return roles(permission).includes(thisRole);
  }
  return false;
}


export function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/** The parsed `user` cookie, or `{}` when it is missing or not valid JSON. */
export function getUserCookie() {
  const raw = getCookie('user');
  return isJson(raw) ? JSON.parse(raw) || {} : {};
}

export function isEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export const imageExists = (img) => {
  var http = new XMLHttpRequest();
  http.open('HEAD', img, false);
  http.send();
  var status = http.status !== 404;
  return status ? img : require('../images/pngs/notfound.png');
}

// Flattens a survey's pages into a single question list, inlining the
// questions of a sub-form page right after the sub-form question itself.
export const flattenSurveyQuestions = pages => {
  return pages.reduce((acc, cur) => {
    if (
      cur.questions.length === 1 &&
      cur.questions[0].type === 'sub-form' &&
      cur.questions[0].subform &&
      cur.questions[0].subform.active_data &&
      (cur.questions[0].subform.active_data.pages || []).length > 0
    ) {
      acc.push(
        cur.questions[0],
        ...cur.questions[0].subform.active_data.pages[0].questions
      );
    } else {
      acc.push(...cur.questions);
    }
    return acc;
  }, []);
};